import { render } from "./ApplicantServiceCard.vue?vue&type=template&id=66c1334e&scoped=true"
import script from "./ApplicantServiceCard.vue?vue&type=script&lang=js"
export * from "./ApplicantServiceCard.vue?vue&type=script&lang=js"

import "./ApplicantServiceCard.vue?vue&type=style&index=0&id=66c1334e&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c1334e"]])

export default __exports__